import React from "react";

import "./AotcScan.scss";
import { Scanner, CustomHeader } from "SharedComponents";
import { ALGORITHMS, PRODUCTS_AOTC } from "Constants";
import { withRouter } from "react-router";

class EmbeddedScan extends React.Component {
  constructor(props) {
    super(props);
    const algorithmKey = this.props.match.params.algorithm;
    this.state = {
      algorithm: ALGORITHMS.find((algo) => algo.key === algorithmKey)
        .projectName,
    };
  }

  componentDidMount() {
    document.title = "AotC Scanner";
  }

  render() {
    return (
      <div className="embedded-scan-page aotc">
        <CustomHeader logo={process.env.PUBLIC_URL + "/aotc-logo.jpg"} />
        <Scanner
          algorithm={this.state.algorithm}
          products={PRODUCTS_AOTC}
          url={this.props.match.url}
          customText={{}}
        />
      </div>
    );
  }
}

export default withRouter(EmbeddedScan);
